var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-tooltip',{attrs:{"bottom":""},scopedSlots:_vm._u([{key:"activator",fn:function({ on }){return [_c('v-icon',_vm._g({staticStyle:{"margin":"0 5px"},attrs:{"color":"orange"},on:{"click":_vm.allIntegrationLogs}},on),[_vm._v(" mdi-form-select ")])]}}])},[_c('span',{domProps:{"textContent":_vm._s(_vm.$t('monitoring.see_all_logs'))}})])
}
var staticRenderFns = []

export { render, staticRenderFns }